import React, { useState, lazy, Suspense } from "react";
import js from "json-random-data-generator";
import "./App.css";
import { saveAs } from "file-saver";

const TextField = lazy(() => import('./components/input/TextField'));
const TextArea = lazy(() => import('./components/input/TextArea'));
const NumberField = lazy(() => import('./components/input/NumberField'));
const ConfigField = lazy(() => import('./components/forms/ConfigField'));

const renderLoader = () => <p>Loading...</p>;

function App() {
  const [fields, setFields] = useState([]);

  const [numberOfObjects, setNumberOfObjects] = useState(10);

  // adding different kinds of fields
  const addArrNumField = () =>
    setFields([
      ...fields,
      { name: "arrayNumberField", type: "arrNum", values: [1, 2, 3, 4] },
    ]);

  const addArrStringField = () =>
    setFields([
      ...fields,
      {
        name: "arrayStringField",
        type: "arrString",
        values: ["trout", "bass", "salmon", "smelt"],
      },
    ]);

  const addNumField = () =>
    setFields([...fields, { name: "number", type: "num", values: [0, 10] }]);
  const addNumSignedField = () =>
    setFields([
      ...fields,
      { name: "numberSigned", type: "numSigned", values: [1, 10] },
    ]);
  const addNumFloatField = () =>
    setFields([
      ...fields,
      { name: "numberFloat", type: "numFloat", values: [0.0, 1.0] },
    ]);
  const addDateField = () =>
    setFields([
      ...fields,
      { name: "date", type: "date", values: [1989, 2020, 2021] },
    ]);
  const addValField = () =>
    setFields([
      ...fields,
      { name: "value", type: "val", values: ["singleValue"] },
    ]);

  const removeField = (index) =>
    setFields(fields.filter((_, i) => index !== i));

  const clearAllFields = () => setFields([]);

  const addValue = (index) =>
    setFields([
      ...fields.filter((_, i) => index > i),
      {
        name: fields[index].name,
        type: fields[index].type,
        values: [...fields[index].values, 1],
      },
      ...fields.filter((_, i) => index < i),
    ]);

  const removeValue = (index, valueIndex) => {
    if (fields[index].values.length < 2) return;
    return setFields([
      ...fields.filter((_, i) => index > i),
      {
        name: fields[index].name,
        type: fields[index].type,
        values: fields[index].values.filter((_, i) => i !== valueIndex),
      },
      ...fields.filter((_, i) => index < i),
    ]);
  };

  const [objectArrayName, setObjectArrayName] = useState("fish");
  const configObj = js.configObject.buildConfigObject({
    objectArrayName: objectArrayName,
    fields: fields.map((e) => ({
      ...e,
      type: (e.type === "arrString") | (e.type === "arrNum") ? "arr" : e.type,
    })),
  });

  const jsonString = js.buildJsonStringFromConfigObject({
    configObject: configObj,
    objectArrayName,
    numberOfObjects,
  });

  const jsonObject = JSON.parse(jsonString);

  const handleObjectValues = (topIndex, index, value, sanitizer) => {
    return setFields([
      ...fields.filter((_, i) => topIndex > i),
      {
        name: fields[topIndex].name,
        type: fields[topIndex].type,
        values: [
          ...fields[topIndex].values.filter((_, i) => index > i),
          sanitizer(value),
          ...fields[topIndex].values.filter((_, i) => index < i),
        ],
      },
      ...fields.filter((_, i) => topIndex < i),
    ]);
  };

  const handleObjectFieldName = (topIndex, value, sanitizer) => {
    return setFields([
      ...fields.filter((_, i) => topIndex > i),
      {
        name: sanitizer(value),
        type: fields[topIndex].type,
        values: fields[topIndex].values,
      },
      ...fields.filter((_, i) => topIndex < i),
    ]);
  };

  const saveJsonFile = () => {
    var blob = new Blob([jsonString], { type: "text/plain;charset=utf-8" });
    saveAs(blob, objectArrayName + ".json");
  };

  return (
    <>
    <div className="AppHeader">
    <h1>JSON Random Data Generator</h1>
    </div>
      <hr/>
          <Suspense fallback={renderLoader()}>
      <TextField
        value={objectArrayName}
        label={"Object Array Name: "}
        onChange={(e) =>
          setObjectArrayName(e.target.value.replace(/[|\\&;$%@"<>()+,]/g, ""))
        }
      />
          </Suspense>
      <div></div>
          <Suspense fallback={renderLoader()}>
      <NumberField
        value={numberOfObjects}
        label={"Number of Objects: "}
        onChange={(e) =>
          setNumberOfObjects(
            e.target.value < 0
              ? 1
              : e.target.value > 10000
              ? 10000
              : parseInt(e.target.value.replace(/[|\-\\&;$%@"<>()+,]/g, ""), 10)
          )
        }
      />
          </Suspense>
      <hr/>
      <div>
      <div>
        <h2>Fields</h2>
      </div>
        <div>
          <h3>Arrays</h3>
          <button onClick={() => addArrNumField()}>
            Add Array Of Numbers Field
          </button>
          <button onClick={() => addArrStringField()}>
            Add Array of Strings Field
          </button>
        </div>
        <div>
          <h3>Numbers</h3>
          <button onClick={() => addNumField()}>Add Number Field</button>
          <button onClick={() => addNumFloatField()}>
            Add Number (float) Field
          </button>
          <button onClick={() => addNumSignedField()}>
            Add Number (signed) Field
          </button>
        </div>
        <div>
          <h3>Other</h3>
          <button onClick={() => addDateField()}>Add Date Field</button>
          <button onClick={() => addValField()}>Add Single Value Field</button>
        </div>
      </div>
      <div>
        <button onClick={() => clearAllFields()}>Clear All Fields</button>
      </div>
      <hr/>
      <div>
        {fields.map(({ name, type, values }, topIndex) => (
          <Suspense fallback={renderLoader()}>
          <ConfigField
            key={type + topIndex + "fieldTopLevel"}
            fieldName={name}
            fieldType={type}
            fieldValues={values}
            topIndex={topIndex}
            addValue={addValue}
            removeField={removeField}
            removeValue={removeValue}
            handleObjectFieldName={handleObjectFieldName}
            handleObjectValues={handleObjectValues}
            chartData={jsonObject[objectArrayName].map((e) => e[name])}
          />
          </Suspense>
        ))}
      </div>
      <div>
          <Suspense fallback={renderLoader()}>
        <TextArea text={{ textString: jsonString }} name="JSONtext" />
          </Suspense>
        <button onClick={() => saveJsonFile()}>Save File</button>
      </div>
      </>
  );
}

export default App;
